import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MainPage } from './pages/main-page';
import { ServiceListPage } from './pages/service/service-list-page';
import { ServiceByIdPage } from './pages/service/service-by-id.page';
import { InsuranceListPage } from './pages/insurance/insurance.page';
import { InsuranceByIdPage } from './pages/insurance/insurance-by-id.page';
import { FuelPage } from './pages/fuel/fuel.page';
import { FuelByIdPage } from './pages/fuel/fuel-by-id.page';
import { CoffeeListPage } from './pages/coffee/coffee-list-page';
import { CoffeeByIdPage } from './pages/coffee/coffee-by-id.page';
import { WashListPage } from './pages/wash/wash-list.page';
import { ChatBotPage } from './pages/other/chat-bot.page';
import { WashByIdPage } from './pages/wash/wash-by-id.page';
import { MainLayout } from './layout/main.layout';


const routesApp = [
  {
    path: "/",
    element: MainLayout,
    children: [
      { path: "", element: MainPage, index: true },
      { path: "service", element: ServiceListPage },
      { path: "service/:serviceId", element: ServiceByIdPage },
      { path: "insurance", element: InsuranceListPage },
      { path: "insurance/:insuranceId", element: InsuranceByIdPage },
      { path: "fuel", element: FuelPage },
      { path: "fuel/:fuelId", element: FuelByIdPage },
      { path: "coffee", element: CoffeeListPage },
      { path: "coffee/:coffeeId", element: CoffeeByIdPage },
      { path: "wash", element: WashListPage },
      { path: "wash/:washId", element: WashByIdPage },
      { path: "chat-bot", element: ChatBotPage }
    ]
  }
];
export const RouterApp = () => {
  return (
    <BrowserRouter>
      <Routes>
        {routesApp.map((route, index) => (
          <Route key={index} path={route.path} element={<route.element />}>
            {route.children && route.children.map((childRoute, childIndex) => (
              <Route
                key={childIndex}
                path={childRoute.path}
                element={<childRoute.element />}
                index={childRoute.index}
              />
            ))}
          </Route>
        ))}
      </Routes>
    </BrowserRouter>
  );
};